import { gatewayClient, createService } from './connectors/httpClient';

const httpClient = gatewayClient('/user');

const userService = createService(httpClient, (client) => ({
    getUser() {
        return client.get('/info');
    },
}));

export default userService;
